module.exports = __webpack_public_path__ + "img/3.4ca4d82a.jpg";